import React, { useEffect, useState } from "react";
import { Col, Container, Dropdown, Form, Image, Row } from "react-bootstrap";
import Button from "@restart/ui/esm/Button";
import blue_tick from "../assets/images/blue_tick.png";
import green_tick from "../assets/images/green_tick.png";
import upload_icon from "../assets/images/upload_icon.png";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { countryCode } from "../Components/CountryCode";
import LocationInput from "./LocationInput";

import {
  QontoConnector,
  BootstrapInput,
  QontoStepIconRoot,
} from "../Components/StepperStuff";
import MenuItem from "@mui/material/MenuItem";
import { Link, useHistory } from "react-router-dom";
import { toast } from "react-toastify";

const CompanySignup = ({
  setActiveForm,
  activeForm,
  handleSubmitCompany,
  companyData,
  setCompanyData,
  handleChangeCompany,
  isApiCall,
}) => {
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [imageFile, setImageFile] = useState(null);

  // geocoding
  useEffect(() => {
    if (address !== "") {
      var city = "";
      for (var i = 0, len = address.address_components.length; i < len; i++) {
        var ac = address.address_components[i];
        if (ac.types.indexOf("locality") >= 0) city = ac.long_name;
      }

      //only report if we got Good Stuff
      if (city != "") {
        setCity(city);
      }
    }
  }, [address]);

  const history = useHistory();
  const [dropDown, setDropDown] = useState({
    Code: "10",
  });
  return (
    <div className="company_signup_bg ">
      <div className="step_form_main ">
        <Container className="container_733 form_mid">
          <h4 className=" font-30">Create a JOBSTER Profile</h4>

          <Row className="mb-5">
            <Col md={6} className="cus_btn_profile1">
              <Button onClick={() => setActiveForm(0)}>Craft</Button>
              {activeForm == 0 && <Image src={green_tick} />}
            </Col>
            <Col md={6} className="cus_btn_profile2">
              <Button onClick={() => setActiveForm(1)}>Companies</Button>
              {activeForm == 1 && <Image src={blue_tick} />}
            </Col>
          </Row>
          <Row>
            <form onSubmit={handleSubmitCompany}>
              <Col md={12} className="mb-3">
                <label
                  class="step_form_3rd_fileupload "
                  onChange={(e) => {
                    if (e.target.files?.length > 0) {
                      if (
                        !["image/jpeg", "image/png", "image/jpg"].includes(
                          e.target.files[0].type
                        )
                      ) {
                        return toast.error(
                          "Please upload a valid image. [jpg and png formats only]"
                        );
                      }

                      setImageFile(e.target.files[0]);
                    }

                    //
                  }}
                >
                  {imageFile != null && imageFile?.name}
                  <div className="innerDiv_fileUpload ">
                    <div className="d-flex j-center a-center upload_btn">
                      <Image src={upload_icon} />
                      <p style={{ margin: 0, marginLeft: 10 }}>Attach Image</p>
                    </div>
                  </div>
                  <input type="file" size="60" class="file_upload_form3rd" />
                </label>
              </Col>
              <Col md={12} className="mb-3">
                <Form.Control
                  type="text"
                  placeholder="Company Name"
                  name="companyName"
                  onChange={handleChangeCompany}
                />
              </Col>
              <Col md={12} className="mb-3">
                {/* <Form.Control
                  type="text"
                  placeholder="Address"
                  name="companyName"
                  onChange={handleChangeCompany}
                /> */}
                <div className="new_loc_css">
                  <LocationInput setPlace={setAddress} />
                </div>
              </Col>
              <Col md={12} className="mb-3">
                <Form.Control
                  type="text"
                  placeholder="Cvr No."
                  name="cvrNo"
                  onChange={handleChangeCompany}
                />
              </Col>
              <Col md={12} className="mb-3">
                <Form.Control
                  type="email"
                  placeholder="Email Address"
                  name="email"
                  onChange={handleChangeCompany}
                />
              </Col>
              <Col md={12} className="mb-3">
                <Form.Control
                  type="password"
                  placeholder="Password"
                  name="password"
                  onChange={handleChangeCompany}
                />
              </Col>
              <Col md={12} className="mb-3">
                <Form.Control
                  type="password"
                  placeholder="Confirm Password"
                  name="passwordConfirm"
                  onChange={handleChangeCompany}
                />
              </Col>
              <div className="d-flex j-between">
                <div className="step_form_col_one">
                  <FormControl variant="standard">
                    <Select
                      className="drop1_new"
                      labelId="demo-customized-select-label"
                      id="demo-customized-select"
                      value={companyData.countryCode}
                      name="countryCode"
                      onChange={handleChangeCompany}
                      defaultValue="value"
                      input={<BootstrapInput />}
                    >
                      {countryCode.map((item, i) => {
                        i == 0 && console.log(item);
                        return (
                          <MenuItem key={i} value={item.dial_code}>
                            <i
                              className={`flag flag-${(item?.code).toLowerCase()}`}
                            ></i>
                            {item.dial_code}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </div>
                {/* <div className="step_form_col_two">
                  <FormControl variant="standard">
                    <Select
                      className="drop1_new"
                      labelId="demo-customized-select-label"
                      id="demo-customized-select"
                      value={dropDown.second}
                      name="category"
                      defaultValue="value"
                      // onChange={handleChange}
                      input={<BootstrapInput />}
                    >
                      <MenuItem value={10}>Code</MenuItem>
                      <MenuItem value={20}>Twenty</MenuItem>
                      <MenuItem value={30}>Thirty</MenuItem>
                    </Select>
                  </FormControl>
                </div> */}
                <div className="step_form_col_three">
                  <Form.Control
                    type="text"
                    placeholder="Mobile Number"
                    name="contactNo"
                    onChange={handleChangeCompany}
                  />
                </div>
              </div>
              <Col md={12} className="mb-3 mt-3">
                <Form.Control
                  type="text"
                  placeholder="Contact Person"
                  name="contactPerson"
                  onChange={handleChangeCompany}
                />
              </Col>
              <Col md={12} className="mb-3 mt-3">
                <Form.Control
                  as="textarea"
                  rows={5}
                  placeholder="Description"
                  name="description"
                  onChange={handleChangeCompany}
                />
              </Col>
              <Col md={12} className="mb-3 mt-3">
                <Button
                  className="step_form_btn_next"
                  variant="contained"
                  color="primary"
                  type="submit"
                  disabled={isApiCall}
                  onClick={(e) =>
                    handleSubmitCompany(e, address, city, imageFile)
                  }
                  // history.push("dashboard");
                >
                  {isApiCall ? "Please wait..." : "Create Account"}
                </Button>
              </Col>
            </form>
          </Row>

          <Col
            md={12}
            className="mb-3 mt-3 text-center alreadyAccountContainer"
          >
            <p>Already have an account? </p>
            <Link to="/signin">Sign In</Link>
          </Col>
        </Container>
      </div>
    </div>
  );
};

export default CompanySignup;
